import { createStore, combineReducers, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import Cookie from "js-cookie";

import { loginReducer } from "./reducers/session";
import {
	createCategoryReducer,
	fetchCategoriesReducer,
	updateCategoryReducer,
	deleteCategoryReducer,
	fetchCategoryReducer,
} from "./reducers/category";

import { fetchTopicsReducer, updateTopicReducer } from "./reducers/topic";
import {
	fetchSurveysReducer,
	fetchSurveyReducer,
	downloadSurveysReducer,
} from "./reducers/survey";
import {
	fetchSurveyScoresReducer,
	updateSurveyScoreReducer,
	fetchSurveyScoreReducer,
} from "./reducers/surveyScore";

import { LOGOUT_REQUEST } from "./constants/session";
import { RESET_CATEGORIES } from "./constants/category";
import { RESET_DOWNLOAD_CSV } from "./constants/survey";
import {
	fetchScoreRulesReducer,
	fetchScoreRuleReducer,
	updateScoreRuleReducer,
} from "./reducers/scoreRule";
import {
	fetchQuestionsReducer,
	fetchQuestionReducer,
	updateQuestionReducer,
	createQuestionReducer,
	deleteQuestionReducer,
} from "./reducers/question";
import {
	fetchAdminsReducer,
	fetchAdminReducer,
	updateAdminReducer,
	createAdminReducer,
	deleteAdminReducer,
} from "./reducers/admin";
import {
	fetchAnswerRulesReducer,
	updateAnswerRuleReducer,
	fetchAnswerRuleReducer,
} from "./reducers/answerRule";
import {
	createMobileVersionReducer,
	deleteMobileVersionReducer,
	fetchMobileVersionsReducer,
	updateMobileVersionReducer,
} from "./reducers/mobileVersion";
import {
	exportShippersReducer,
	fetchShippersReducer,
} from "./reducers/shipper";
import {
	createSpinGameReducer,
	deleteSpinGameReducer,
	fetchSpinGameReducer,
	fetchSpinGamesReducer,
	updateSpinGameReducer,
} from "./reducers/spinTheWheelGame";
import { RESET_DELETE_SPIN_GAME } from "./constants/spinTheWheelGame";
import {
	createSpinGameMessageReducer,
	deleteSpinGameMessageReducer,
	fetchSpinGameMessageReducer,
	fetchSpinGameMessagesReducer,
	updateSpinGameMessageReducer,
} from "./reducers/spinTheWheelGameMessage";
import { RESET_DELETE_SPIN_GAME_MESSAGE } from "./constants/spinTheWheelGameMessage";
import {
	createSpinRateReducer,
	deleteSpinRateReducer,
	fetchSpinRateReducer,
	fetchSpinRatesReducer,
	updateSpinRateReducer,
} from "./reducers/spinTheWheelRate";
import { RESET_DELETE_SPIN_RATE } from "./constants/spinTheWheelRate";
import {
	createSpinRewardReducer,
	deleteSpinRewardReducer,
	fetchSpinRewardReducer,
	fetchSpinRewardsReducer,
	updateSpinRewardReducer,
} from "./reducers/spinTheWheelReward";
import { RESET_DELETE_SPIN_REWARD } from "./constants/spinTheWheelReward";
import {
	exportSpinReducer,
	fetchSpinReducer,
	fetchSpinsReducer,
} from "./reducers/spinTheWheelOverview";
import { fetchSpinReportsReducer } from "./reducers/spinTheWheelReport";
import {
	createNotificationReducer,
	deleteNotificationReducer,
	fetchNotificationReducer,
	fetchNotificationsReducer,
	fetchStoresReducer,
	updateNotificationReducer,
} from "./reducers/notification";
import { RESET_DELETE_NOTIFICATION } from "./constants/notification";
import {
	createMaintenanceReducer,
	deleteMaintenanceReducer,
	fetchMaintenanceReducer,
	fetchMaintenancesReducer,
	updateMaintenanceReducer,
} from "./reducers/maintenance";

const adminInfo = Cookie.getJSON("adminInfo") || "";
const initalState = { login: { adminInfo } };

const reducer = combineReducers({
	login: loginReducer,
	createCategory: createCategoryReducer,
	fetchCategories: fetchCategoriesReducer,
	updateCategory: updateCategoryReducer,
	deleteCategory: deleteCategoryReducer,
	fetchCategory: fetchCategoryReducer,
	fetchTopics: fetchTopicsReducer,
	updateTopic: updateTopicReducer,
	fetchSurveyScores: fetchSurveyScoresReducer,
	updateSurveyScore: updateSurveyScoreReducer,
	fetchSurveyScore: fetchSurveyScoreReducer,
	fetchScoreRules: fetchScoreRulesReducer,
	fetchScoreRule: fetchScoreRuleReducer,
	fetchQuestions: fetchQuestionsReducer,
	fetchQuestion: fetchQuestionReducer,
	updateQuestion: updateQuestionReducer,
	updateScoreRule: updateScoreRuleReducer,
	fetchAnswerRules: fetchAnswerRulesReducer,
	updateAnswerRule: updateAnswerRuleReducer,
	fetchAnswerRule: fetchAnswerRuleReducer,
	createQuestion: createQuestionReducer,
	deleteQuestion: deleteQuestionReducer,
	fetchAdmins: fetchAdminsReducer,
	fetchAdmin: fetchAdminReducer,
	createAdmin: createAdminReducer,
	updateAdmin: updateAdminReducer,
	deleteAdmin: deleteAdminReducer,
	fetchSurveys: fetchSurveysReducer,
	fetchSurvey: fetchSurveyReducer,
	downloadSurveys: downloadSurveysReducer,
	createMobileVersion: createMobileVersionReducer,
	fetchMobileVersions: fetchMobileVersionsReducer,
	updateMobileVersion: updateMobileVersionReducer,
	deleteMobileVersion: deleteMobileVersionReducer,
	fetchShippers: fetchShippersReducer,
	exportShippers: exportShippersReducer,
	createSpinGame: createSpinGameReducer,
	fetchSpinGames: fetchSpinGamesReducer,
	updateSpinGame: updateSpinGameReducer,
	deleteSpinGame: deleteSpinGameReducer,
	fetchSpinGame: fetchSpinGameReducer,
	createSpinGameMessage: createSpinGameMessageReducer,
	fetchSpinGameMessages: fetchSpinGameMessagesReducer,
	updateSpinGameMessage: updateSpinGameMessageReducer,
	deleteSpinGameMessage: deleteSpinGameMessageReducer,
	fetchSpinGameMessage: fetchSpinGameMessageReducer,
	createSpinRate: createSpinRateReducer,
	fetchSpinRates: fetchSpinRatesReducer,
	updateSpinRate: updateSpinRateReducer,
	deleteSpinRate: deleteSpinRateReducer,
	fetchSpinRate: fetchSpinRateReducer,
	createSpinReward: createSpinRewardReducer,
	fetchSpinRewards: fetchSpinRewardsReducer,
	updateSpinReward: updateSpinRewardReducer,
	deleteSpinReward: deleteSpinRewardReducer,
	fetchSpinReward: fetchSpinRewardReducer,
	fetchSpins: fetchSpinsReducer,
	fetchSpin: fetchSpinReducer,
	exportSpins: exportSpinReducer,
	fetchSpinReports: fetchSpinReportsReducer,
	createNotification: createNotificationReducer,
	fetchNotifications: fetchNotificationsReducer,
	updateNotification: updateNotificationReducer,
	deleteNotification: deleteNotificationReducer,
	fetchNotification: fetchNotificationReducer,
	fetchStores: fetchStoresReducer,
	fetchMaintenances: fetchMaintenancesReducer,
	updateMaintenance: updateMaintenanceReducer,
	createMaintenance: createMaintenanceReducer,
	fetchMaintenance: fetchMaintenanceReducer,
	deleteMaintenance: deleteMaintenanceReducer,
});

const rootReducer = (state, action) => {
	switch (action.type) {
		case LOGOUT_REQUEST:
			state.login = {};
			break;
		case RESET_CATEGORIES:
			state.createCategory = {};
			state.fetchCategories = {};
			state.updateCategory = {};
			break;
		case RESET_DELETE_SPIN_GAME:
			state.deleteSpinGame = {};
			break;
		case RESET_DELETE_SPIN_GAME_MESSAGE:
			state.deleteSpinGameMessage = {};
			break;
		case RESET_DELETE_SPIN_RATE:
			state.deleteSpinRate = {};
			break;
		case RESET_DELETE_SPIN_REWARD:
			state.deleteSpinReward = {};
			break;
		case RESET_DOWNLOAD_CSV:
			state.downloadSurveys = {};
			state.exportShippers = {};
			break;
		case RESET_DELETE_NOTIFICATION:
			state.deleteNotification = {};
			break;
	}

	return reducer(state, action);
};

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = applyMiddleware(thunk);

const store = createStore(
	rootReducer,
	initalState,
	composeEnhancer(middleware),
);

export default store;
